import React, { Component } from 'react';
import ReactSpeedometer from "react-d3-speedometer";
import Windmill from '../../images/Windmill.jpg';

import DesktopBreakpoint from './responsive_utilities/desktop_breakpoint';
import TabletBreakpoint from './responsive_utilities/tablet_breakpoint';
import PhoneBreakpoint from './responsive_utilities/phone_breakpoint';
import SmallPhoneBreakpoint from './responsive_utilities/small_phone_breakpoint';

//const url = 'http://localhost:5006/api/GVM/';

const url = 'http://gvm.itoperators.dk:5006/api/GVM/';


export default class GvGeneratorsSpeedometer extends Component {
  static propTypes = {

  };

state = {
      GV1Power: [],
      GV2Power: [],
      GV3Power: [],
    CurrentLiveApplier: 'plus',
    }

  componentDidMount() {
    this.fetchGeneratorData();
    this.timerID = setInterval(
      () => this.fetchGeneratorData(),
      2500
    );
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  fetchGeneratorData = async () => {
    if(this.state.CurrentLiveApplier === 'plus') {
          this.setState({CurrentLiveApplier: 'minus'})
      } else {
          this.setState({CurrentLiveApplier: 'plus'})
      }
    let GV1PowerCall = await fetch(url + '1', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'GridPower' }});
    let GV2PowerCall = await fetch(url + '2', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'GridPower' }});
    let GV3PowerCall = await fetch(url + '3', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'GridPower' }}); 

     await Promise.all([GV1PowerCall, GV2PowerCall, GV3PowerCall])    
      .then(([res1, res2, res3]) => Promise.all([res1.json(), res2.json(), res3.json()]))
      .then(([data1, data2, data3]) => this.setState({
          GV1Power: data1,
          GV2Power: data2,
          GV3Power: data3
      }));
  }

  round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }

  getRandom() {
    const min = 10;
    const max = 100;
    return min + Math.random() * (max - min);
  }

  render() {    

    let totalMWProduction = Math.round(((this.state.GV1Power.value + this.state.GV2Power.value + this.state.GV3Power.value)) * 100) / 100;

    //console.log('Total MW Production: ' + totalMWProduction);

    if(isNaN(totalMWProduction)) {
      totalMWProduction = 0;
    }
    if(this.state.CurrentLiveApplier === 'plus') {
      totalMWProduction = totalMWProduction + this.round(this.getRandom(), 1);      
    }
    else {
      totalMWProduction = totalMWProduction - this.round(this.getRandom(), 1);      
    }


    let formattedValue = new Intl.NumberFormat('de-DE').format(totalMWProduction);

    return (
      <div>
        <img src={Windmill} alt="" />      
        <DesktopBreakpoint>          
          <ReactSpeedometer
                foreceRender={true}    
                width={500}
                height={280} 
                maxValue={30000}
                value={totalMWProduction}
                needleColor="#2A3539"
                startColor="#05F26C"
                maxSegmentLabels={8}
                segments={1000}
                endColor="#038C33"
                currentValueText={"kW : " + formattedValue}
                needleTransitionDuration={5000}
                needleTransition="easeElastic"
            />     
          </DesktopBreakpoint> 

          <TabletBreakpoint>
            <ReactSpeedometer
                  foreceRender={true}    
                  width={400}
                  height={230} 
                  maxValue={30000}
                  value={totalMWProduction}
                  needleColor="#2A3539"
                  startColor="#05F26C"
                  maxSegmentLabels={8}
                  segments={1000}
                  endColor="#038C33"
                  currentValueText={"kW : " + formattedValue}
                  needleTransitionDuration={5000}
                  needleTransition="easeElastic"
              />     
          </TabletBreakpoint> 

          <PhoneBreakpoint>
            <ReactSpeedometer
                  foreceRender={true}    
                  width={300}
                  height={180} 
                  maxValue={30000}
                  value={totalMWProduction}
                  needleColor="#2A3539"
                  startColor="#05F26C"
                  maxSegmentLabels={8}
                  segments={1000}
                  endColor="#038C33"
                  currentValueText={"kW : " + formattedValue}
                  needleTransitionDuration={5000}
                  needleTransition="easeElastic"
              />     
          </PhoneBreakpoint> 

          <SmallPhoneBreakpoint>
            <ReactSpeedometer
                  foreceRender={true}    
                  width={300}
                  height={180} 
                  maxValue={30000}
                  value={totalMWProduction}
                  needleColor="#2A3539"
                  startColor="#05F26C"
                  maxSegmentLabels={8}
                  segments={1000}
                  endColor="#038C33"
                  currentValueText={"kW : " + formattedValue}
                  needleTransitionDuration={5000}
                  needleTransition="easeElastic"
              />     
          </SmallPhoneBreakpoint> 
        </div>  
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/GvGeneratorsSpeedometer.js